// extracted by mini-css-extract-plugin
module.exports =  {"hidden":"RatingActions__hidden--f1666"};